
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("cxAFf", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $hwDTW = parcelRequire("hwDTW");


var $4jETc = parcelRequire("4jETc");

var $cmWXZ = parcelRequire("cmWXZ");


var $k3207 = parcelRequire("k3207");

const $1004d7345af5d08f$export$bc8645ef40313f94 = ({ shortcutsConfig: shortcutsConfig, cloudId: cloudId, product: product, isShortcutsStatic: isShortcutsStatic, onError: onError })=>{
    const { buildURLAndFetchData: buildURLAndFetchData, status: status, productLinks: productLinks, error: error } = (0, $cmWXZ.useBFFDataProvider)({
        request: {},
        cloudId: cloudId,
        forceStatic: isShortcutsStatic,
        product: product
    });
    // fetch the data from the bff if required
    (0, $42omo.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hwDTW)))(shortcutsConfig) || isShortcutsStatic || !cloudId) return;
        buildURLAndFetchData();
    }, [
        buildURLAndFetchData,
        cloudId,
        shortcutsConfig,
        isShortcutsStatic
    ]);
    (0, $42omo.useEffect)(()=>{
        if (status === (0, $4jETc.RequestStatus).ERROR && error) onError?.(error);
    }, [
        status,
        error,
        onError
    ]);
    // associate shortcuts with the returned bff data
    const hydratedAppShortcuts = (0, $42omo.useMemo)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hwDTW)))(shortcutsConfig)) return shortcutsConfig;
        const config = shortcutsConfig;
        if (status === (0, $4jETc.RequestStatus).COMPLETE && Object.keys(productLinks).length) {
            const isArray = Array.isArray(config);
            if (isArray) return config.reduce((acc, item)=>{
                // if config does not need a data reference, just return the value
                if (item.type !== 'link' || !item.apsKey) {
                    acc.push(item);
                    return acc;
                }
                // if config requires the bff to determine the data reference
                const productLink = productLinks[item.apsKey];
                if (productLink) {
                    const filteredProductLink = cloudId ? productLink.filter((0, $k3207.productLinksWorkspaceCloudIdFilter)(cloudId))[0] : productLink[0];
                    acc.push({
                        ...item,
                        url: filteredProductLink.url
                    });
                }
                return acc;
            }, []);
            const entries = Object.entries(config);
            return entries.reduce((acc, [key, value])=>{
                // if config does not need a data reference, just return the value
                if (value.type !== 'link' || !value.apsKey) {
                    acc[key] = value;
                    return acc;
                }
                // if config requires the bff to determine the data reference
                const productLink = productLinks[value.apsKey];
                if (productLink) {
                    const filteredProductLink = cloudId ? productLink.filter((0, $k3207.productLinksWorkspaceCloudIdFilter)(cloudId))[0] : productLink[0];
                    acc[key] = {
                        ...value,
                        url: filteredProductLink.url
                    };
                    return acc;
                }
                return acc;
            }, {});
        }
        return shortcutsConfig;
    }, [
        productLinks,
        status,
        shortcutsConfig,
        cloudId
    ]);
    return hydratedAppShortcuts;
};
module.exports["useGlobalShortcutsData"] = $1004d7345af5d08f$export$bc8645ef40313f94;

});

parcelRegister("cmWXZ", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");


var $4jETc = parcelRequire("4jETc");


var $6lFYf = parcelRequire("6lFYf");


var $6Tx9o = parcelRequire("6Tx9o");


var $7TOrm = parcelRequire("7TOrm");


var $ik19A = parcelRequire("ik19A");


var $cdX3N = parcelRequire("cdX3N");

async function $f19027b153d497cf$var$wait(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
function $f19027b153d497cf$export$a00b492c9c3c66db({ request: request, cloudId: cloudId, orgId: orgId, product: product, userId: userId, forceStatic: forceStatic }) {
    const { items: cachedItems, addItemsToCache: addItemsToCache, clearCache: clearCache, cacheKey: cacheKey, updateCacheKey: updateCacheKey } = (0, $6Tx9o.useCache)();
    const { status: status, error: error, setStatus: setStatus } = (0, $ik19A.useStatus)();
    const { productLinks: productLinks } = (0, $7TOrm.useProductLinks)({
        cloudId: cloudId,
        orgId: orgId,
        forceStatic: forceStatic
    });
    const { buildURL: buildURL } = (0, $cdX3N.useURLBuilder)({
        cloudId: cloudId,
        userId: userId,
        product: product
    });
    const currentRequest = (0, $42omo.useRef)(null);
    const fetchData = (0, $42omo.useCallback)(async (url, data, attemptCount = 1, successCheck)=>{
        if (url === '') throw new Error('URL is empty');
        // Always clear error status at the start of a new request
        setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.BFF_REQUEST_STATUS_KEY), undefined);
        try {
            const response = await (0, $6lFYf.fetchJSON)(url, {});
            switch(response.status){
                case (0, $4jETc.RequestStatus).ERROR:
                    throw response.error;
                case (0, $4jETc.RequestStatus).COMPLETE:
                    setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.BFF_REQUEST_STATUS_KEY), undefined);
                    currentRequest.current = null;
                    return response.data;
            }
        } catch (error) {
            const maxAttempts = request?.maxAttempts ?? ((0, $dh538.fg)('navx-4044-set-default-retry-logic-to-none') ? (0, $4jETc.MAX_ATTEMPTS_NEW_DEFAULT) : (0, $4jETc.MAX_ATTEMPTS_DEFAULT));
            if (request?.shouldRetryOnException && attemptCount < maxAttempts) {
                const baseInterval = request?.attemptInterval ?? (0, $4jETc.RETRY_INTERVAL_DEFAULT);
                // Exponential backoff: delay doubles with each attempt (1x, 2x, 4x)
                const delay = request?.enableExponentialDelay ? baseInterval * Math.pow(2, attemptCount - 1) : baseInterval;
                await $f19027b153d497cf$var$wait(delay);
                return await fetchData(url, data, attemptCount + 1, successCheck);
            } else {
                currentRequest.current = null;
                setStatus((0, $4jETc.RequestStatus).ERROR, undefined, error instanceof Error ? error : new Error(String(error)));
                throw error;
            }
        }
    }, [
        request?.attemptInterval,
        request?.maxAttempts,
        request?.shouldRetryOnException,
        request?.enableExponentialDelay,
        setStatus
    ]);
    /**
	 * Helper function to build a URL and fetch data.
	 */ const buildURLAndFetchData = (0, $42omo.useCallback)(async ()=>{
        // Wait for the current request to end before firing another
        if (currentRequest.current) return currentRequest.current;
        const builtUrl = buildURL({});
        if (builtUrl !== '') {
            currentRequest.current = fetchData(builtUrl, undefined, undefined, undefined);
            const fetchedData = await currentRequest.current;
            if (!!fetchedData?.sites?.length) addItemsToCache(fetchedData.sites);
        }
    }, [
        addItemsToCache,
        buildURL,
        fetchData
    ]);
    return {
        error: error,
        status: status,
        cachedItems: cachedItems,
        cacheKey: cacheKey,
        updateCacheKey: updateCacheKey,
        addItemsToCache: addItemsToCache,
        clearCache: clearCache,
        buildURL: buildURL,
        fetchData: fetchData,
        buildURLAndFetchData: buildURLAndFetchData,
        productLinks: productLinks
    };
}
module.exports["useBFFDataProvider"] = $f19027b153d497cf$export$a00b492c9c3c66db;

});

parcelRegister("7TOrm", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $g58eM = parcelRequire("g58eM");


var $lzcvT = parcelRequire("lzcvT");


var $4jETc = parcelRequire("4jETc");


var $adIf3 = parcelRequire("adIf3");


var $iAFAo = parcelRequire("iAFAo");


var $6Tx9o = parcelRequire("6Tx9o");


var $ik19A = parcelRequire("ik19A");

function $e49dbd0b56d8db18$var$checkShouldRemoveJWM(productType) {
    return [
        'JIRA_SOFTWARE',
        'JIRA_PRODUCT_DISCOVERY',
        'JIRA_SERVICE_DESK'
    ].includes(productType);
}
const $e49dbd0b56d8db18$var$flightdeckClient = new (0, $g58eM.default)('atlassian-navigagtion-bff-data-provider');
function $e49dbd0b56d8db18$export$79322ba781a26ce1({ cloudId: cloudId, orgId: orgId, forceStatic: forceStatic }) {
    const { items: items } = (0, $6Tx9o.useCache)();
    const { setStatus: setStatus } = (0, $ik19A.useStatus)();
    const [fdResponse, setFdResponse] = (0, $42omo.useState)(null);
    const [productConfig, setProductConfig] = (0, $42omo.useState)(null);
    (0, $42omo.useEffect)(()=>{
        const getFlightdeckData = async ()=>{
            try {
                setStatus((0, $4jETc.RequestStatus).LOADING, (0, $4jETc.FLIGHTDECK_REQUEST_STATUS_KEY));
                const fdResponse = await $e49dbd0b56d8db18$var$flightdeckClient.fetchConfigFromFlightDeck({
                    // app-switcher-fe is currently the only valid name that is configured
                    // in Flightdeck
                    name: 'app-switcher-fe',
                    // This should get updated to be based on the supplied consumer
                    // name: `app-global-shortcuts-${consumer}-fe`,
                    dimensions: {
                        environmentType: 'prod',
                        perimeter: (0, $lzcvT.isFedRamp)() ? 'fedramp-moderate' : 'commercial'
                    }
                });
                setFdResponse(fdResponse);
                setStatus((0, $4jETc.RequestStatus).COMPLETE, (0, $4jETc.FLIGHTDECK_REQUEST_STATUS_KEY));
            } catch  {
                setStatus((0, $4jETc.RequestStatus).ERROR, (0, $4jETc.FLIGHTDECK_REQUEST_STATUS_KEY));
            }
        };
        if (!fdResponse && !forceStatic) getFlightdeckData();
    }, [
        fdResponse,
        setStatus,
        forceStatic
    ]);
    (0, $42omo.useEffect)(()=>{
        if (!fdResponse) return;
        const config = {};
        for (const product of fdResponse.products){
            const { apsKey: apsKey, tcsProductKey: tcsProductKey, siteUrlSuffix: siteUrlSuffix, displayName: displayName, rebrandedDisplayName: rebrandedDisplayName, subtitle: subtitle, ordinal: ordinal, iconKey: iconKey, rebrandedIconKey: rebrandedIconKey } = product;
            config[apsKey] = {
                key: !!tcsProductKey ? tcsProductKey : apsKey.toLowerCase(),
                siteUrlSuffix: siteUrlSuffix,
                ordinal: ordinal,
                label: (0, $iAFAo.formatText)(displayName),
                rebrandedLabel: rebrandedDisplayName && (0, $iAFAo.formatText)(rebrandedDisplayName),
                description: (0, $iAFAo.formatText)(subtitle),
                iconKey: iconKey,
                rebrandedIconKey: rebrandedIconKey
            };
            // TODO: remove this once Asset app becomes standalone app
            if (apsKey === 'JIRA_SERVICE_DESK' && !config[0, $4jETc.ASSETS_APP_KEY]) config[0, $4jETc.ASSETS_APP_KEY] = {
                key: (0, $4jETc.ASSETS_APP_KEY),
                siteUrlSuffix: '/jira/assets',
                ordinal: ordinal + 0.1,
                label: (0, $iAFAo.formatText)('Assets'),
                iconKey: 'assets'
            };
        }
        setProductConfig(config);
    }, [
        fdResponse
    ]);
    const getProductLinkForItem = (0, $42omo.useCallback)((productType, siteUrl, productUrl)=>{
        if (productUrl) return productUrl;
        const siteSuffix = productConfig?.[productType]?.siteUrlSuffix;
        return `${siteUrl}${siteSuffix}`;
    }, [
        productConfig
    ]);
    const productLinks = (0, $42omo.useMemo)(()=>{
        const products = {};
        const shouldRemoveJWM = items.some((item)=>{
            return (item.availableProducts || []).some(({ productType: productType })=>$e49dbd0b56d8db18$var$checkShouldRemoveJWM(productType));
        });
        items.forEach((item)=>{
            const { availableProducts: availableProducts = [], cloudId: cachedItemCloudId, avatar: avatar, url: siteUrl, displayName: displayName, org: org } = item;
            // only apply org level filtering if org data is available
            if (org && orgId && org.id !== orgId) return;
            availableProducts.forEach((product)=>{
                const { url: productUrl } = product;
                let { productType: productType } = product;
                const isExcludeJiraBusiness = productType === 'JIRA_BUSINESS' && !shouldRemoveJWM;
                // if a site has JWM only and no other Jiras, JWM needs to appear under "Jira"
                // to ensure that this happens, we set JSM's productType to 'JIRA_SOFTWARE'
                // this will ensure that JWM is not removed, even if another site has JSW/JPD/JSM
                if (isExcludeJiraBusiness) productType = 'JIRA_SOFTWARE';
                if (!products[productType]) products[productType] = [];
                if (!isExcludeJiraBusiness) products[productType].push({
                    isCurrentSite: Boolean(cachedItemCloudId) && cloudId?.toLowerCase() === cachedItemCloudId?.toLowerCase(),
                    displayName: displayName,
                    url: getProductLinkForItem(productType, siteUrl, productUrl),
                    avatar: avatar,
                    cloudId: cachedItemCloudId
                });
            });
        });
        return (0, $adIf3.sortArraysInObject)(products, (a, b)=>{
            return (0, $iAFAo.sortAlphabetically)('asc')(a.displayName, b.displayName);
        });
    }, [
        items,
        orgId,
        cloudId,
        getProductLinkForItem
    ]);
    return {
        productLinks: productLinks
    };
}
module.exports["useProductLinks"] = $e49dbd0b56d8db18$export$79322ba781a26ce1;

});

parcelRegister("adIf3", function(module, exports) {
function $c62ed403d6258f10$export$3e8bbf689f8e6cad(record, sortFunction) {
    for(const key in record)if (Array.isArray(record[key])) record[key].sort(sortFunction); // Sorts alphabetically or numerically by default
    return record;
}
module.exports["sortArraysInObject"] = $c62ed403d6258f10$export$3e8bbf689f8e6cad;

});

parcelRegister("k3207", function(module, exports) {
const $c124c8c0b6cfb1b3$export$54a1da5292674ec8 = (workspaceCloudId)=>(item, index, arr)=>{
        const matchedItem = arr.find((productLink)=>{
            return productLink.cloudId === workspaceCloudId;
        });
        // If an item exists in the parent array with the same cloudId,
        // we don't want to show a flyout and instead only want the list
        // of available product links to include the matching cloudId.
        if (matchedItem) return workspaceCloudId === item.cloudId;
        // If the filter gets here we want to only pass the first item
        return index === 0;
    };
module.exports["productLinksWorkspaceCloudIdFilter"] = $c124c8c0b6cfb1b3$export$54a1da5292674ec8;

});

parcelRegister("gasvu", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ffCOo = parcelRequire("ffCOo");


var $dh538 = parcelRequire("dh538");


var $eyWa4 = parcelRequire("eyWa4");


var $hnvzE = parcelRequire("hnvzE");


var $iKHTh = parcelRequire("iKHTh");


var $4jETc = parcelRequire("4jETc");

var $caUKj = parcelRequire("caUKj");

var $cmWXZ = parcelRequire("cmWXZ");


var $dBtY8 = parcelRequire("dBtY8");

var $5IDSL = parcelRequire("5IDSL");


var $fqJ57 = parcelRequire("fqJ57");


var $cDmj9 = parcelRequire("cDmj9");


var $cxAFf = parcelRequire("cxAFf");


var $geKgP = parcelRequire("geKgP");


var $5hYae = parcelRequire("5hYae");


var $7akkr = parcelRequire("7akkr");

function $26f372a5788858af$export$bae2da217bf9db6(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $hnvzE.default), {
        name: (0, $cDmj9.UFO_SEGMENT_GLOBAL_SHORTCUTS_NAME),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $caUKj.BFFProvider), {
            consumer: (0, $4jETc.BFFConsumerEnum).GLOBAL_SHORTCUTS,
            children: /*#__PURE__*/ (0, $l998X.jsx)($26f372a5788858af$var$GlobalShortcutsInner, {
                ...props
            })
        })
    });
}
function $26f372a5788858af$var$GlobalShortcutsInner(props) {
    const { cloudId: cloudId, forceStatic: forceStatic, product: product, shortcutItems: rawShortcutItems, onUpdateGetFilteredProductLinks: onUpdateGetFilteredProductLinks } = props;
    const onUpdateGetFilteredProductLinksRef = (0, $42omo.useRef)(onUpdateGetFilteredProductLinks);
    onUpdateGetFilteredProductLinksRef.current = onUpdateGetFilteredProductLinks;
    const { handleError: handleError } = (0, $5IDSL.useNavBoundaryContext)({
        location: (0, $dBtY8.ERROR_LOCATION__GLOBAL_SHORTCUTS),
        // Log backend errors only to Sentry
        // see: https://hello.atlassian.net/wiki/spaces/navx/pages/6439960649/NavX+-+FE+Observability#%3Acatchemall%3A--Error-handling
        sentryConfig: {
            product: product
        },
        disableAnalytics: true
    });
    const shortcutItems = (0, $cxAFf.useGlobalShortcutsData)({
        shortcutsConfig: rawShortcutItems,
        cloudId: cloudId,
        isShortcutsStatic: forceStatic,
        onError: handleError,
        product: product
    });
    const { status: status, productLinks: productLinks } = (0, $cmWXZ.useBFFDataProvider)({
        request: {},
        cloudId: cloudId,
        forceStatic: true,
        product: product
    });
    const productLinksRef = (0, $42omo.useRef)(productLinks);
    productLinksRef.current = productLinks;
    const getBffProductLinksForKey = (0, $42omo.useCallback)((apsKey)=>({
            links: productLinksRef.current[apsKey] ?? [],
            status: status
        }), [
        status
    ]);
    (0, $42omo.useEffect)(()=>{
        if (onUpdateGetFilteredProductLinksRef.current) onUpdateGetFilteredProductLinksRef.current(getBffProductLinksForKey);
    }, [
        getBffProductLinksForKey
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)($26f372a5788858af$export$d64b9883b9bde88c, {
        ...props,
        shortcutItems: shortcutItems
    });
}
function $26f372a5788858af$export$d64b9883b9bde88c({ testId: testId, shortcutItems: shortcutItems = [], product: product, enableDragAndDrop: enableDragAndDrop, viewAllAppsConfig: viewAllAppsConfig = {}, openInSameTab: openInSameTab }) {
    const mappedShortcutItems = (0, $42omo.useMemo)(()=>{
        return shortcutItems.map((item, index)=>{
            let key = item.type === 'link' && item.apsKey || `shortcut-${index}`;
            if (item.type === 'component' && (0, $dh538.fg)('navx-3539-custom-shortcut-component-draggable')) key = item?.apsKey ? item.apsKey : `shortcut-${index}`;
            return {
                ...item,
                key: key
            };
        });
    }, [
        shortcutItems
    ]);
    const createLinkItem = (0, $42omo.useCallback)((shortcut)=>{
        if (shortcut.type === 'component' && (0, $dh538.fg)('navx-3539-custom-shortcut-component-draggable')) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5hYae.ShortcutMenuItem), {
            shortcut: shortcut,
            dragAndDropEnabled: enableDragAndDrop
        }, shortcut.key);
        return /*#__PURE__*/ (0, $l998X.jsx)((0, $5hYae.ShortcutMenuItem), {
            shortcut: shortcut,
            openInSameTab: openInSameTab,
            product: product
        }, shortcut.key);
    }, [
        product,
        openInSameTab,
        enableDragAndDrop
    ]);
    const shortcutList = /*#__PURE__*/ (0, $l998X.jsxs)((0, $iKHTh.MenuList), {
        children: [
            mappedShortcutItems?.map(createLinkItem),
            viewAllAppsConfig?.path && /*#__PURE__*/ (0, $l998X.jsx)((0, $7akkr.ViewAllAppsItem), {
                ...viewAllAppsConfig,
                product: product
            })
        ]
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fqJ57.GlobalShortcutsWithIntlProvider), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $ffCOo.NavigationAnalyticsContext), {
            data: {
                product: product
            },
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $eyWa4.default), {
                testId: testId,
                children: enableDragAndDrop ? /*#__PURE__*/ (0, $l998X.jsx)((0, $geKgP.DragAndDropOptionsProvider), {
                    enabled: enableDragAndDrop,
                    children: shortcutList
                }) : shortcutList
            })
        })
    });
}
module.exports["GlobalShortcuts"] = $26f372a5788858af$export$bae2da217bf9db6;

});

parcelRegister("fqJ57", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $keVvA = parcelRequire("keVvA");


var $7FdE1 = parcelRequire("7FdE1");


var $6h453 = parcelRequire("6h453");

const $a5ea78601091ee04$var$fetchMessagesForLocale = async (locale)=>{
    try {
        // Fallback to the generic locale if specified one is not found
        const languageLocale = locale in (0, $6h453.asyncLanguages) ? locale : locale.split(/[-_]/)[0] || '';
        // Dynamic import of the locale file
        const localeMessages = await (0, $6h453.asyncLanguages)[languageLocale]?.();
        return localeMessages?.default ?? (0, $7FdE1.default);
    } catch (e) {
    // ignore
    }
    return 0, $7FdE1.default;
};
const $a5ea78601091ee04$export$6b89dea1a4334953 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $keVvA.default), {
        defaultMessages: (0, $7FdE1.default),
        loaderFn: $a5ea78601091ee04$var$fetchMessagesForLocale,
        children: children
    });
};
module.exports["GlobalShortcutsWithIntlProvider"] = $a5ea78601091ee04$export$6b89dea1a4334953;

});

parcelRegister("7FdE1", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a39680e968b16aaa$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ 
var $4yBJM = parcelRequire("4yBJM");

var $a39680e968b16aaa$export$2e2bcd8739ae039 = (0, $4yBJM.default);

});

parcelRegister("6h453", function(module, exports) {

























const $b8f2a3af0ad05925$export$3770c7a7737d463c = {
    cs: ()=>(parcelRequire("jChHs")),
    da: ()=>(parcelRequire("j2IgT")),
    de: ()=>(parcelRequire("aEYqs")),
    'en-GB': ()=>(parcelRequire("eWFBW")),
    'en-ZZ': ()=>(parcelRequire("8fBlO")),
    en: ()=>Promise.resolve((parcelRequire("7FdE1"))),
    es: ()=>(parcelRequire("462Za")),
    fi: ()=>(parcelRequire("gguBH")),
    fr: ()=>(parcelRequire("7vOYR")),
    hu: ()=>(parcelRequire("hGch9")),
    it: ()=>(parcelRequire("gPvuv")),
    ja: ()=>(parcelRequire("aWtte")),
    ko: ()=>(parcelRequire("5IhIf")),
    nb: ()=>(parcelRequire("gJ5fT")),
    nl: ()=>(parcelRequire("cLFvF")),
    pl: ()=>(parcelRequire("4EE52")),
    'pt-BR': ()=>(parcelRequire("ksgid")),
    ru: ()=>(parcelRequire("6y7Tp")),
    sv: ()=>(parcelRequire("5DR7g")),
    th: ()=>(parcelRequire("78H9t")),
    tr: ()=>(parcelRequire("e63Aa")),
    uk: ()=>(parcelRequire("c5u43")),
    vi: ()=>(parcelRequire("gM64v")),
    zh_TW: ()=>(parcelRequire("kJlYi")),
    zh: ()=>(parcelRequire("8wemY"))
};
module.exports["asyncLanguages"] = $b8f2a3af0ad05925$export$3770c7a7737d463c;

});

parcelRegister("jChHs", function(module, exports) {

let $e47f4bc41d89147d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $e47f4bc41d89147d$var$load("4Mixi"),
    $e47f4bc41d89147d$var$load("1jsQH"),
    $e47f4bc41d89147d$var$load("bv8GZ"),
    $e47f4bc41d89147d$var$load("i9sd0"),
    $e47f4bc41d89147d$var$load("i5eMd"),
    $e47f4bc41d89147d$var$load("4DYJ5"),
    $e47f4bc41d89147d$var$load("gyXEE"),
    $e47f4bc41d89147d$var$load("hoPZ9")
]).then(()=>parcelRequire('br2f9'));

});

parcelRegister("4mJKd", function(module, exports) {
"use strict";


let $32dcb3648bfd454e$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("8tirZ")).shardUrl((parcelRequire("02nRr")).resolve(id), maxShards));
    };
module.exports = $32dcb3648bfd454e$var$load;

});

parcelRegister("8tirZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $62af5803f3d08114$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $62af5803f3d08114$var$getDomainShardIndex;
module.exports.shardUrl = $62af5803f3d08114$var$shardUrl;
module.exports.shardUrlUnchecked = $62af5803f3d08114$var$shardUrlUnchecked;
const $62af5803f3d08114$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $62af5803f3d08114$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $62af5803f3d08114$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $62af5803f3d08114$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $62af5803f3d08114$var$removeTrailingShard(subdomain) {
    if (!$62af5803f3d08114$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $62af5803f3d08114$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$62af5803f3d08114$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $62af5803f3d08114$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $62af5803f3d08114$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $62af5803f3d08114$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $62af5803f3d08114$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $62af5803f3d08114$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$62af5803f3d08114$var$globalKeyName]) return url;
    return $62af5803f3d08114$var$shardUrlUnchecked(url, maxShards);
}
const $62af5803f3d08114$var$domainShardingKey = module.exports.domainShardingKey = $62af5803f3d08114$var$globalKeyName;

});

parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

parcelRegister("j2IgT", function(module, exports) {

let $ddd08ba3a0b254e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ddd08ba3a0b254e7$var$load("cjveN"),
    $ddd08ba3a0b254e7$var$load("deyvi"),
    $ddd08ba3a0b254e7$var$load("cdeuH"),
    $ddd08ba3a0b254e7$var$load("aNg21"),
    $ddd08ba3a0b254e7$var$load("4UPfH"),
    $ddd08ba3a0b254e7$var$load("hfFxJ"),
    $ddd08ba3a0b254e7$var$load("1Mp9N"),
    $ddd08ba3a0b254e7$var$load("2Fu3d")
]).then(()=>parcelRequire('5T7BQ'));

});

parcelRegister("aEYqs", function(module, exports) {

let $7c2c8319f69ebf0e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7c2c8319f69ebf0e$var$load("8XGJb"),
    $7c2c8319f69ebf0e$var$load("6dERU"),
    $7c2c8319f69ebf0e$var$load("7gF8f"),
    $7c2c8319f69ebf0e$var$load("YEGhv"),
    $7c2c8319f69ebf0e$var$load("gd4qs"),
    $7c2c8319f69ebf0e$var$load("gofGr"),
    $7c2c8319f69ebf0e$var$load("dBb6q"),
    $7c2c8319f69ebf0e$var$load("eJgH8")
]).then(()=>parcelRequire('f72Ys'));

});

parcelRegister("eWFBW", function(module, exports) {

let $ae16c285e4f9d202$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ae16c285e4f9d202$var$load("aSjrK"),
    $ae16c285e4f9d202$var$load("03aeW")
]).then(()=>parcelRequire('9Uzok'));

});

parcelRegister("8fBlO", function(module, exports) {

let $601cb2872ee22d6b$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $601cb2872ee22d6b$var$load("4ViGN"),
    $601cb2872ee22d6b$var$load("j0PWv"),
    $601cb2872ee22d6b$var$load("ksTQ6"),
    $601cb2872ee22d6b$var$load("j5F5K"),
    $601cb2872ee22d6b$var$load("eBoC7"),
    $601cb2872ee22d6b$var$load("7NpX8"),
    $601cb2872ee22d6b$var$load("cukQS"),
    $601cb2872ee22d6b$var$load("5FaEJ")
]).then(()=>parcelRequire('hFCKc'));

});

parcelRegister("462Za", function(module, exports) {

let $2fba09d2f88d14db$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $2fba09d2f88d14db$var$load("32vlK"),
    $2fba09d2f88d14db$var$load("dlmud"),
    $2fba09d2f88d14db$var$load("5CGnz"),
    $2fba09d2f88d14db$var$load("dXu4x"),
    $2fba09d2f88d14db$var$load("bNv64"),
    $2fba09d2f88d14db$var$load("bFU3Y"),
    $2fba09d2f88d14db$var$load("3CucM"),
    $2fba09d2f88d14db$var$load("9yemY")
]).then(()=>parcelRequire('kosLT'));

});

parcelRegister("gguBH", function(module, exports) {

let $bd75e1dcf711f658$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $bd75e1dcf711f658$var$load("bjoGV"),
    $bd75e1dcf711f658$var$load("cbkj0"),
    $bd75e1dcf711f658$var$load("9Oxgj"),
    $bd75e1dcf711f658$var$load("18TX5"),
    $bd75e1dcf711f658$var$load("4Afgd"),
    $bd75e1dcf711f658$var$load("exaJ2"),
    $bd75e1dcf711f658$var$load("lp8Wm"),
    $bd75e1dcf711f658$var$load("l2LZP")
]).then(()=>parcelRequire('ggDJR'));

});

parcelRegister("7vOYR", function(module, exports) {

let $5782f95340b1f1e1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $5782f95340b1f1e1$var$load("8oiz7"),
    $5782f95340b1f1e1$var$load("17m16"),
    $5782f95340b1f1e1$var$load("kAg8V"),
    $5782f95340b1f1e1$var$load("9Cdzw"),
    $5782f95340b1f1e1$var$load("cMubu"),
    $5782f95340b1f1e1$var$load("hcCcg"),
    $5782f95340b1f1e1$var$load("cHWSM"),
    $5782f95340b1f1e1$var$load("35Ssm")
]).then(()=>parcelRequire('4f1t8'));

});

parcelRegister("hGch9", function(module, exports) {

let $cdefe19a51c9f6dd$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $cdefe19a51c9f6dd$var$load("hFxmj"),
    $cdefe19a51c9f6dd$var$load("b4NO6"),
    $cdefe19a51c9f6dd$var$load("fM2oh"),
    $cdefe19a51c9f6dd$var$load("guNAg"),
    $cdefe19a51c9f6dd$var$load("3fLE9"),
    $cdefe19a51c9f6dd$var$load("j9KTb"),
    $cdefe19a51c9f6dd$var$load("b37xN"),
    $cdefe19a51c9f6dd$var$load("ik6u5")
]).then(()=>parcelRequire('3xm6B'));

});

parcelRegister("gPvuv", function(module, exports) {

let $c409d639049f12f9$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c409d639049f12f9$var$load("BXOZB"),
    $c409d639049f12f9$var$load("1K1Fj"),
    $c409d639049f12f9$var$load("xnqy2"),
    $c409d639049f12f9$var$load("cM3gY"),
    $c409d639049f12f9$var$load("8hOn0"),
    $c409d639049f12f9$var$load("3hjAq"),
    $c409d639049f12f9$var$load("7PjNK"),
    $c409d639049f12f9$var$load("Vt6S9")
]).then(()=>parcelRequire('abc2w'));

});

parcelRegister("aWtte", function(module, exports) {

let $7f762e6658de7b17$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $7f762e6658de7b17$var$load("9Xiuh"),
    $7f762e6658de7b17$var$load("38sfA"),
    $7f762e6658de7b17$var$load("awkVi"),
    $7f762e6658de7b17$var$load("6yRq3"),
    $7f762e6658de7b17$var$load("h4OCL"),
    $7f762e6658de7b17$var$load("2bCHJ"),
    $7f762e6658de7b17$var$load("ktSfi"),
    $7f762e6658de7b17$var$load("9GZ76")
]).then(()=>parcelRequire('iOsEl'));

});

parcelRegister("5IhIf", function(module, exports) {

let $428ecd2c26e0f998$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $428ecd2c26e0f998$var$load("7Odo3"),
    $428ecd2c26e0f998$var$load("bjmre"),
    $428ecd2c26e0f998$var$load("11DLa"),
    $428ecd2c26e0f998$var$load("cft22"),
    $428ecd2c26e0f998$var$load("bcQs2"),
    $428ecd2c26e0f998$var$load("fdXnq"),
    $428ecd2c26e0f998$var$load("iouLY"),
    $428ecd2c26e0f998$var$load("4sOIV")
]).then(()=>parcelRequire('aIqdH'));

});

parcelRegister("gJ5fT", function(module, exports) {

let $c2d4ecea84d57981$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c2d4ecea84d57981$var$load("4VkvT"),
    $c2d4ecea84d57981$var$load("asvK9"),
    $c2d4ecea84d57981$var$load("barSq"),
    $c2d4ecea84d57981$var$load("gctEz"),
    $c2d4ecea84d57981$var$load("aBa7j"),
    $c2d4ecea84d57981$var$load("cItJR"),
    $c2d4ecea84d57981$var$load("hPZE5"),
    $c2d4ecea84d57981$var$load("QTjdE")
]).then(()=>parcelRequire('6B9u2'));

});

parcelRegister("cLFvF", function(module, exports) {

let $94ba12cb2f0b80d1$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $94ba12cb2f0b80d1$var$load("g5qJV"),
    $94ba12cb2f0b80d1$var$load("7v6wU"),
    $94ba12cb2f0b80d1$var$load("a8heY"),
    $94ba12cb2f0b80d1$var$load("9PPH7"),
    $94ba12cb2f0b80d1$var$load("b544F"),
    $94ba12cb2f0b80d1$var$load("SctKm"),
    $94ba12cb2f0b80d1$var$load("dzIm8"),
    $94ba12cb2f0b80d1$var$load("hrf1M")
]).then(()=>parcelRequire('bZefw'));

});

parcelRegister("4EE52", function(module, exports) {

let $3639fcf9a6d6a860$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $3639fcf9a6d6a860$var$load("dPa6p"),
    $3639fcf9a6d6a860$var$load("aEpRh"),
    $3639fcf9a6d6a860$var$load("6hlNE"),
    $3639fcf9a6d6a860$var$load("1y1eN"),
    $3639fcf9a6d6a860$var$load("K6fhx"),
    $3639fcf9a6d6a860$var$load("1fJz1"),
    $3639fcf9a6d6a860$var$load("jqwnR"),
    $3639fcf9a6d6a860$var$load("lsloj")
]).then(()=>parcelRequire('kzj9p'));

});

parcelRegister("ksgid", function(module, exports) {

let $ee430f952078e029$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $ee430f952078e029$var$load("iG4uh"),
    $ee430f952078e029$var$load("3fuR9"),
    $ee430f952078e029$var$load("2bqSD"),
    $ee430f952078e029$var$load("e8jpx"),
    $ee430f952078e029$var$load("gZU54"),
    $ee430f952078e029$var$load("9yA8o"),
    $ee430f952078e029$var$load("bGhLc"),
    $ee430f952078e029$var$load("iRKhU")
]).then(()=>parcelRequire('5JjoD'));

});

parcelRegister("6y7Tp", function(module, exports) {

let $4c4c0a6515b253e7$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $4c4c0a6515b253e7$var$load("9tVE8"),
    $4c4c0a6515b253e7$var$load("fMrUo"),
    $4c4c0a6515b253e7$var$load("bJykp"),
    $4c4c0a6515b253e7$var$load("fjbzp"),
    $4c4c0a6515b253e7$var$load("4Wdqb"),
    $4c4c0a6515b253e7$var$load("448N7"),
    $4c4c0a6515b253e7$var$load("9v6ER"),
    $4c4c0a6515b253e7$var$load("aEAsN")
]).then(()=>parcelRequire('kJ9vR'));

});

parcelRegister("5DR7g", function(module, exports) {

let $41b9cc0bb4e99a9a$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $41b9cc0bb4e99a9a$var$load("6UAlo"),
    $41b9cc0bb4e99a9a$var$load("9eNkX"),
    $41b9cc0bb4e99a9a$var$load("dh2Er"),
    $41b9cc0bb4e99a9a$var$load("1pFHs"),
    $41b9cc0bb4e99a9a$var$load("k10Cs"),
    $41b9cc0bb4e99a9a$var$load("gBDdh"),
    $41b9cc0bb4e99a9a$var$load("8Mz40"),
    $41b9cc0bb4e99a9a$var$load("l6YHr")
]).then(()=>parcelRequire('vKazA'));

});

parcelRegister("78H9t", function(module, exports) {

let $532ac0d0a30e5dbf$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $532ac0d0a30e5dbf$var$load("fdczG"),
    $532ac0d0a30e5dbf$var$load("6nK39")
]).then(()=>parcelRequire('3GtCy'));

});

parcelRegister("e63Aa", function(module, exports) {

let $a43467985c6d32a2$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $a43467985c6d32a2$var$load("epkdv"),
    $a43467985c6d32a2$var$load("hWNfo")
]).then(()=>parcelRequire('72BhT'));

});

parcelRegister("c5u43", function(module, exports) {

let $8ccd45d65bf67c8e$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $8ccd45d65bf67c8e$var$load("3MGOs"),
    $8ccd45d65bf67c8e$var$load("8UuQQ")
]).then(()=>parcelRequire('6yNb3'));

});

parcelRegister("gM64v", function(module, exports) {

let $c365d6c2c8c7b614$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $c365d6c2c8c7b614$var$load("innCz"),
    $c365d6c2c8c7b614$var$load("6BkMx")
]).then(()=>parcelRequire('74VfG'));

});

parcelRegister("kJlYi", function(module, exports) {

let $f1790db32eb94c09$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $f1790db32eb94c09$var$load("ia9y3"),
    $f1790db32eb94c09$var$load("j9OUx"),
    $f1790db32eb94c09$var$load("bV8sS"),
    $f1790db32eb94c09$var$load("kKXTS"),
    $f1790db32eb94c09$var$load("l079e"),
    $f1790db32eb94c09$var$load("ebljE"),
    $f1790db32eb94c09$var$load("hF4v3"),
    $f1790db32eb94c09$var$load("afU9w")
]).then(()=>parcelRequire('hP4wC'));

});

parcelRegister("8wemY", function(module, exports) {

let $633c756180636b6d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $633c756180636b6d$var$load("15ncj"),
    $633c756180636b6d$var$load("gDiIK"),
    $633c756180636b6d$var$load("eLlpV"),
    $633c756180636b6d$var$load("7sItg"),
    $633c756180636b6d$var$load("f1B4n"),
    $633c756180636b6d$var$load("j4dSZ"),
    $633c756180636b6d$var$load("1Tuyb"),
    $633c756180636b6d$var$load("7iCpI")
]).then(()=>parcelRequire('hc8vA'));

});

parcelRegister("cDmj9", function(module, exports) {
const $0bc646091c24cf0e$export$fe240e33002221f = 'global-shortcuts-platform-component';
const $0bc646091c24cf0e$export$2158b6d23c9689f5 = 'global-shortcuts-data-loading';
module.exports["UFO_SEGMENT_GLOBAL_SHORTCUTS_NAME"] = $0bc646091c24cf0e$export$fe240e33002221f;

});

parcelRegister("7akkr", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");


var $6bJyJ = parcelRequire("6bJyJ");


var $5hYae = parcelRequire("5hYae");


var $hWCSe = parcelRequire("hWCSe");

function $0b19012007f6ee0e$export$84e063904618ed06({ path: path, isSelected: isSelected, product: product, onNavigate: onNavigate }) {
    const { formatMessage: formatMessage } = (0, $1cfRh.default)();
    const analyticsName = 'VIEW_ALL_APPS';
    if (!path || path.trim().length < 1) return null;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $5hYae.ShortcutMenuItem), {
        shortcut: {
            key: analyticsName,
            analyticsName: analyticsName,
            label: formatMessage((0, $hWCSe.messages).viewAllAppsLabel),
            icon: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6bJyJ))), {
                label: ""
            }),
            url: path,
            isReorderable: false,
            type: 'internal',
            isSelected: isSelected,
            onClick: onNavigate
        },
        product: product
    });
}
module.exports["ViewAllAppsItem"] = $0b19012007f6ee0e$export$84e063904618ed06;

});

parcelRegister("hWCSe", function(module, exports) {

var $h82at = parcelRequire("h82at");

const $0b4de72332c147b6$export$defe85febe8b728c = (0, $h82at.defineMessages)({
    viewAllAppsLabel: {
        id: "navigation.global-shortcuts.view-all-apps.label",
        defaultMessage: "View all apps"
    }
});
module.exports["messages"] = $0b4de72332c147b6$export$defe85febe8b728c;

});


//# sourceMappingURL=GlobalAppShortcutsSection.e8277168.js.map
